import { getCompanyId, setCompanyId, setSysRoleId } from '@/lib/token';
import { logOut } from '@/services/user.service';
import { CheckOutlined, HomeOutlined, LogoutOutlined } from '@ant-design/icons';
import { Link, useModel } from '@umijs/max';
import { Dropdown, MenuProps, Space, Spin, Tag } from 'antd';
import { ItemType } from 'antd/es/menu/interface';
import _ from 'lodash';
import React, { useMemo } from 'react';
import styles from './index.less';

type GlobalHeaderRightProps = {
  menu?: boolean;
};

const AvatarDropdown: React.FC<GlobalHeaderRightProps> = () => {
  const { initialState } = useModel('@@initialState');
  const itemsLoading: MenuProps['items'] = [
    {
      icon: <LogoutOutlined />,
      key: 'logout',
      label: '退出登录',
    },
  ];

  const items = useMemo(() => {
    const _items: ItemType[] = [];
    const roleItems = _.map(initialState?.roles, (role) => ({
      label: role.name,
      icon: role.id === initialState?.companyRoleId ? <CheckOutlined /> : null,
      key: `role:${role.id}`,
    }));
    if (!_.isEmpty(roleItems)) {
      _items.push({
        type: 'group',
        label: '运营角色',
        children: roleItems,
      });
    }
    const companyItems = _.map(initialState?.companies, (company) => ({
      label: company?.name,
      icon: company.id === initialState?.companyId ? <CheckOutlined /> : null,
      key: `company:${company?.id}`,
    }));
    if (!_.isEmpty(companyItems)) {
      _items.push({
        type: 'group',
        label: '企业',
        children: companyItems,
      });
    }
    _items.push(
      {
        type: 'divider',
      },
      {
        icon: <HomeOutlined />,
        key: 'companyInfo',
        label: <Link to={`/resource/company/${getCompanyId()}/home`}>企业信息</Link>,
      },
    );
    _items.push(
      {
        type: 'divider',
      },
      {
        icon: <LogoutOutlined />,
        key: 'logout',
        label: '退出登录',
      },
    );
    return _items;
  }, []);
  if (!initialState) {
    return (
      <Dropdown
        menu={{
          items: itemsLoading,
          onClick: ({ key }) => {
            if (key === 'logout') {
              logOut();
            }
          },
        }}
        overlayStyle={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}
      >
        <Space>
          <Spin
            size="small"
            style={{
              marginLeft: 8,
              marginRight: 8,
            }}
          />
          <Tag color="warning">未授权用户</Tag>
        </Space>
      </Dropdown>
    );
  }

  const { user } = initialState;

  return (
    <div className="pr-6">
      <Dropdown
        classNames={{ root: styles.dropDown }}
        menu={{
          className: styles.menu,
          mode: 'inline',
          onClick: ({ key }) => {
            if (key === 'logout') {
              logOut();
            }
            if (key.startsWith('company:')) {
              setCompanyId(_.get(key.split(':'), 1));
              location.reload();
            }
            if (key.startsWith('role:')) {
              setSysRoleId(_.get(key.split(':'), 1));
              location.reload();
            }
          },
          items,
        }}
        placement="bottomLeft"
      >
        {user?.username || user?.mobile}
      </Dropdown>
    </div>
  );
};

export default AvatarDropdown;
